// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog {
    color: #000;
    position: fixed;
    top: 0;
    left: 0;
    width: 95%;
    height: 95%;
    display: flex;
    justify-content: center;
    border-radius: 20px;
    border-width: 3px;
    border-color: #20295b;
    align-items: center;
    z-index: 9999;
  }
  
  .dialog-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    max-height: 90%;
    max-width: 95%;
    overflow: auto;
    border: 2px solid #20295b; /* Thin black border */
  }

  .dialog-content-mobile {
    background-color: #fff;
    border-radius: 8px;
    width: 90%;
    max-height: 90%;
    max-width: 95%;
    overflow: auto;
    border: 2px solid #20295b; /* Thin black border */
  }
  
  .dialog h2 {
    margin-bottom: 20px;
  }
  
  .dialog button {
    margin-top: 10px;
    margin-right: 10px;
  }
  
  .fixed-buttons-dialog {
    position: sticky;
    border-bottom: 0px;
    bottom: -20px;
    background-color: white;
    padding: 0px;
    display: flex;
    justify-content: space-around;
    width: 100%;
    z-index: 0;
  }
  
  .dialog-list-container {
    padding: 20px;
  }
  `, "",{"version":3,"sources":["webpack://./src/css/components/Dialog.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,cAAc;IACd,cAAc;IACd,yBAAyB,EAAE,sBAAsB;EACnD;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,cAAc;IACd,cAAc;IACd,yBAAyB,EAAE,sBAAsB;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;EACf","sourcesContent":[".dialog {\r\n    color: #000;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 95%;\r\n    height: 95%;\r\n    display: flex;\r\n    justify-content: center;\r\n    border-radius: 20px;\r\n    border-width: 3px;\r\n    border-color: #20295b;\r\n    align-items: center;\r\n    z-index: 9999;\r\n  }\r\n  \r\n  .dialog-content {\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    width: 90%;\r\n    max-height: 90%;\r\n    max-width: 95%;\r\n    overflow: auto;\r\n    border: 2px solid #20295b; /* Thin black border */\r\n  }\r\n\r\n  .dialog-content-mobile {\r\n    background-color: #fff;\r\n    border-radius: 8px;\r\n    width: 90%;\r\n    max-height: 90%;\r\n    max-width: 95%;\r\n    overflow: auto;\r\n    border: 2px solid #20295b; /* Thin black border */\r\n  }\r\n  \r\n  .dialog h2 {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .dialog button {\r\n    margin-top: 10px;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .fixed-buttons-dialog {\r\n    position: sticky;\r\n    border-bottom: 0px;\r\n    bottom: -20px;\r\n    background-color: white;\r\n    padding: 0px;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    width: 100%;\r\n    z-index: 0;\r\n  }\r\n  \r\n  .dialog-list-container {\r\n    padding: 20px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
